import { render, staticRenderFns } from "./CardVisualBox.vue?vue&type=template&id=5d10ba50&scoped=true&"
import script from "./CardVisualBox.vue?vue&type=script&lang=js&"
export * from "./CardVisualBox.vue?vue&type=script&lang=js&"
import style0 from "./CardVisualBox.vue?vue&type=style&index=0&id=5d10ba50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d10ba50",
  null
  
)

export default component.exports